import React from 'react';

import classNames from 'classnames';

import SelectAdvancedFilter from 'components/lib/SelectAdvancedFilter';
import { COMMUNITY_AUDIT_TYPE, COMMUNITY_AUDIT_TYPE_LABEL } from 'constants/audits';
import { SelectAdvancedFilterOptionType } from 'types/common';

import { useCommunitiesContext } from './CommunitiesContext';

const CommunitiesControlsFiltersAuditType = () => {
  const { filters, setFilters } = useCommunitiesContext();

  const handleSelectAuditTypes = (values: SelectAdvancedFilterOptionType[]) => {
    const selection = (values ?? []).map((item: SelectAdvancedFilterOptionType) => item.value);
    setFilters({ ...filters, auditTypes: selection });
  };

  const auditTypeOptions = Object.values(COMMUNITY_AUDIT_TYPE).map((auditTypeId) => ({
    label: COMMUNITY_AUDIT_TYPE_LABEL[auditTypeId],
    value: auditTypeId,
  }));

  return (
    <SelectAdvancedFilter
      className={classNames({ active: filters?.auditTypes && filters.auditTypes.length > 0 })}
      placeholder={'Audit Type'}
      options={auditTypeOptions}
      defaultValue={filters?.auditTypes ?? []}
      onSelect={handleSelectAuditTypes}
    />
  );
};

export default CommunitiesControlsFiltersAuditType;
